export const trip_details_events = {
  trip_details_page_load: {
    category: "User loads trip details page",
    action: "User clicks on image card",
    label: "trip-details-page-load",
  },

  trip_details_flight_tab_load: {
    category: "User changed to flight tab",
    action: "User clicks flight tab",
    label: "trip-details-flight-tab-load",
  },
  trip_details_hotel_tab_load: {
    category: "User changed to hotel tab",
    action: "User clicks hotel tab",
    label: "trip-details-hotel-tab-load",
  },

  trip_details_back_click: {
    category: "User navigates back to today page",
    action: "User clicks on back button",
    label: "trip-details-back-click",
  },
  trip_details_daily_activity_accordion_click: {
    category: "User can view the daily activities ",
    action: "User clicks on the accordion icon ",
    label: "trip-details-daily-activity-accordion-click",
  },

  // Flight details events
  trip_details_flights_cancel_option_click: {
    category: "It cancel the options for flight",
    action: "User clicks on the flights cancel option button",
    label: "trip-details-flights-cancel-option-click",
  },
  trip_details_flights_change_flight_click: {
    category: "It allows the user to change flight optionls",
    action: "User clicks on the change flights edit button",
    label: "trip-details-flights-change-flight-click",
  },
  trip_details_flight_share_click: {
    category: "It allows the user to share flight",
    action: "User clicks on the share button",
    label: "trip-details-flight-share-click",
  },
  trip_details_flight_help_click: {
    category: "It allows the user to contact support",
    action: "User clicks on the help button",
    label: "trip-details-flight-help-click",
  },

  trip_details_flight_traveler_accordion_click: {
    category: "It includes all the traveler information",
    action: "User clicks on the traveler accordion icon ",
    label: "trip-details-flight-traveler-accordion-click",
  },
  trip_details_flight_payment_accordion_click: {
    category: "It includes all the payment information",
    action: "User clicks on the payment accordion icon ",
    label: "trip-details-flight-payment-accordion-click",
  },

  trip_details_hotel_cancel_option_click: {
    category: "It cancel the options for hotel",
    action: "User clicks on the hotel cancel option button",
    label: "trip-details-hotel-cancel-option-click",
  },
  trip_details_hotel_change_hotel_click: {
    category: "It allows the user to change hotel optionls",
    action: "User clicks on the change hotel edit button",
    label: "trip-details-hotel-change-hotel-click",
  },
  trip_details_hotel_share_click: {
    category: "It allows the user to share hotel",
    action: "User clicks on the share button",
    label: "trip-details-hotel-share-click",
  },
  trip_details_hotel_help_click: {
    category: "It allows the user to contact support",
    action: "User clicks on the help button",
    label: "trip-details-hotel-help-click",
  },
};
